import React, { lazy, Suspense } from "react";
import { Routes, Route } from 'react-router-dom';
import './App.css';
const Start = lazy(() => import("./pages/Start"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const BudgetTracker = lazy(() => import("./components/BudgetTracker"));
const ProtectedRoute =  lazy(() => import("./components/ProtectedRoute"));

function App() {
  return (
      <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Start />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<div>Page Not Found</div>} />
          {/* Protected Route */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <BudgetTracker />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
      </Suspense>
  );
}

export default App;
